export const NO_MODIFIER_MESSAGE_HEADER = 'No Modifier Sets Created';
export const NO_MODIFIER_MESSAGE_MESSAGE = 'Click "Create New Set" to get started.';

export const SERVER_ERROR_MESSAGE_DELETING =
  'Failed to delete modifier set. Please try again and contact customer support if the error persists.';
export const DELETE_BUTTON_HELP_MESSAGE = 'Delete modifier set.';
